import { FORWARD_NOTE_MAX } from '@raro/domain';
import { Forward, Icon, cx, type ForwardPerson } from '@raro/ui';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useLocation } from 'react-router';
import { api } from '../lib/api';

/**
 * Encaminhar a tela aberta a alguém da equipe Raro, como se encaminha um post: chega no sino e por e-mail e abre aqui.
 * `title` é o que a pessoa vai ler (o nome do tema, da hipótese); `context`, de onde é. O endereço é o da tela, com o que
 * está aberto; `href` troca quando a tela não guarda a escolha no endereço.
 */
export function Encaminhar({ title, context, href, className = 'rr-action rr-action--bare' }: { title: string; context?: string; href?: string; className?: string }) {
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const people = useQuery({ queryKey: ['forward', 'people'], queryFn: () => api.get<ForwardPerson[]>('/notifications/forward/people'), enabled: open, staleTime: 300_000 });
  const send = useMutation({ mutationFn: (v: { userIds: string[]; note: string }) => api.post('/notifications/forward', { ...v, note: v.note || undefined, title, context, href: href ?? `${loc.pathname}${loc.search}` }) });
  const error = (e: unknown) => (e instanceof Error ? e.message : 'não foi possível encaminhar: tente de novo');
  return (
    <>
      <button type="button" className={cx(className, 'rr-forward__btn')} onClick={() => { send.reset(); setOpen(true); }}><Icon name="send" size={14} />encaminhar</button>
      <Forward open={open} onClose={() => setOpen(false)} what={title} context={context} people={people.data} noteMax={FORWARD_NOTE_MAX}
        onSend={(userIds, note) => send.mutateAsync({ userIds, note })} busy={send.isPending} error={people.isError ? error(people.error) : send.isError ? error(send.error) : null} />
    </>
  );
}
